import ReferralTerms from './ReferralTerms';
export default ReferralTerms;